/* 劉備傳・第 11 章：夷陵・白帝託孤（章武二年～三年，222–223）
 * 史實：《三國志·陸遜傳》陸遜「乃敕各持一把茅，以火攻拔之」，連破四十餘營；「備因夜遁，……僅得入白帝城」。
 *       《諸葛亮傳》：劉備病篤，對諸葛亮說「君才十倍曹丕，必能安國，終定大事。若嗣子可輔，輔之；如其不才，君可自取。」
 * 流程：操作劉備。火從最東邊的營燒起，順著西風沿連營燒過來；到每座營站著下令撤營，營裡的兵就跟著走；
 *       吳軍從東邊追來。往西撤到白帝城即結束，託孤的旁白卡收尾。（和孫吳傳第 18 章同一場仗、同一張圖。） */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, TROOPS } from '../kit.ts';
import { CAMPS, WU } from '../maps/yiling.ts';

const LV = 15, BAIDI = [400, 2050];
const WUJUN = { spec: SG.SOLDIERS.wu, name: '吳軍', hp: 480, maxHp: 480, atk: 28, ms: 230 };

export default {
  id: 'liubei-11', map: 'yiling', hero: 'liubei',
  title: '第 11 章　夷陵・白帝託孤', year: '章武二年（222）',
  brief: {
    quote: [{ text: '君才十倍曹丕，必能安國，終定大事。若嗣子可輔，輔之；如其不才，君可自取。', src: '《三國志·蜀書·諸葛亮傳》' }],
    text: '關羽死後，劉備稱帝，親率大軍伐吳，從巫峽到夷陵連營數百里。陸遜堅守不戰，等蜀軍疲憊、移營入林。',
    goals: ['火起：到各營下令撤營', '往西撤到白帝城'],
  },
  words: { ally: '蜀兵', foe: '吳軍' },
  fuel(m, x, y) { return CAMPS.some(([cx, cy]) => SG.gd(x, y, cx, cy) < 420) || (Math.abs(y - 2050) < 260 && x > 1700 && x < 7900 && !SG.MAP.waterAt(x, y)); },
  spreadMul() { return 0.9; },
  stars: [
    { text: '撤出 5 座營以上', ok: (m) => m.vars.saved >= 5 },
    { text: '帶 12 人以上到白帝城', ok: (m) => m.vars.out >= 12 },
    { text: '劉備的生命保住一半以上', ok: (m) => m.vars.hpMin >= 0.5 },
  ],
  steps: [
    { // 1. 火燒連營：撤營
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMPS[3][0]; me.y = CAMPS[3][1] + 150;
        V.saved = 0; V.hpMin = 1;
        V.camps = CAMPS.map(([x, y], k) => { m.mark('c' + k, x, y, '撤營', true); return { x, y, done: false, men: Array.from({ length: 3 }, (_, i) => { const u = m.recruit(x - 80 + i * 80, y + 120, '蜀兵'); u.spec = TROOPS.shu; return u; }) }; });
        m.wind = [-1, 0.05];
        m.after(4, () => { m.big('吳軍火攻！'); m.card('乃敕各持一把茅，以火攻拔之。', '《陸遜傳》'); for (const d of [[-140, 0], [-220, 70], [-220, -70]]) m.fire(CAMPS[0][0] + d[0], CAMPS[0][1] + d[1], { dps: 80 }); });
        V.chaseT = 14;
        m.line('劉備', '東邊起火了？……是陸遜！');
        m.after(6, () => m.line('提示', '到每座營站著不動，下令撤營，營裡的兵就會跟上。火順著西風燒過來，吳軍也從東邊追來。'));
        m.mark('bd', BAIDI[0], BAIDI[1], '白帝城');
        m.obj('camps', '到各營下令撤營', CAMPS.length);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.hpMin = Math.min(V.hpMin, me.hp / me.maxHp);
        V.camps.forEach((c, k) => {
          if (c.done) return;
          if (m.burning(c.x, c.y, 200)) { c.done = 'lost'; m.unmark('c' + k); for (const u of c.men) if (u.alive) { u.alive = false; u.counted = true; } return; }
          m.chanAt(me, 'c' + k, c.x, c.y + 60, 220, 1.5, '撤營', () => { c.done = true; V.saved++; m.unmark('c' + k); for (const u of c.men) if (u.alive) m.join(u, me); }, { hurt: false });
        });
        m.prog('camps', V.saved);
        // 吳軍從東邊追來
        V.chaseT -= dt;
        if (V.chaseT <= 0) { V.chaseT = 12; for (let i = 0; i < 5; i++) { const p = SG.MAP.nearestFree(WU[0] - 600 - i * 40, WU[1] + (i - 2) * 80); const u = m.foe('huangjin', p[0], p[1], WUJUN); u.home = [me.x, me.y]; } }
        for (const u of w.units) if (u.team === 1 && u.alive && !(u.target && u.target.alive) && u.name === '吳軍') u.home = [me.x, me.y];
        return m.near(me, BAIDI[0], BAIDI[1], 320);
      },
    },
    { // 2. 白帝託孤
      enter(m, w) {
        const V = m.vars, me = w.player;
        V.out = w.units.filter((u) => u.recruit && u.alive && u.owner === me).length;
        m.done('camps'); m.unmark('bd');
        m.card('備因夜遁，……僅得入白帝城。', '《陸遜傳》');
        m.after(5, () => m.card('「君才十倍曹丕，必能安國，終定大事。若嗣子可輔，輔之；如其不才，君可自取。」', '《諸葛亮傳》（劉備臨終託孤）'));
        m.after(12, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('劉備陣亡'); },
};
